import { filter, groupBy, keys, mapObjIndexed, sort } from "ramda";
import { sortAlpha } from "widgets/utils";

import type { ProjectBasisFragment } from "@/modules/projects/graphql/projects-queries.gql.ts";

import type { Group, GroupsWithProjects } from "./types";

export const splitProjectsAndFolders = sort<ProjectBasisFragment | null>((a, b) => {
  if (a?.color && b?.color) return 0;
  if (a?.color && !b?.color) return -1;
  if (b?.color && !a?.color) return 1;
  return 0;
});

export const getProjectsByUserGroups = (
  userGroups: (Group | null)[] | null | undefined = [],
): GroupsWithProjects | null => {
  // group by {"User Group Name": Group}
  const byGroup = groupBy<Group | null>((group) => group?.name ?? "Unknown");
  const groupsByKey = byGroup(userGroups ?? []);

  // extract projects => {"User Group Name", Project[]}
  const allGroupsAndProjects = mapObjIndexed((groups) => {
    const projects = groups?.[0]?.accessibleProjects ?? [];
    const alphaSortedProjects = sort((a, b) => sortAlpha(a?.name ?? "", b?.name ?? ""), projects);

    // Put "folders" at the end.
    return splitProjectsAndFolders(alphaSortedProjects);
  }, groupsByKey);

  const _filtered = filter((value) => Array.isArray(value) && !!value.length, allGroupsAndProjects) as Record<
    string,
    ProjectBasisFragment[]
  >;

  return keys(_filtered).length == 0 ? null : _filtered;
};
